import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAnimatePath: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="animate-path, animation, jump"><path d="M2.75 19.25C2.75 17.1591 3.875 7.75 7.25 7.75C10.625 7.75 11.75 17.1591 11.75 19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M11.75 19.3752C11.75 18.3467 12.1426 13.4635 16.0035 9.14502" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><circle cx="18.5" cy="7.5" r="2.75" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconAnimatePath;
